import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { PodSimulatorStore, PodSimulatorState } from './pod-simulator.store';

@Injectable({ providedIn: 'root' })
export class PodSimulatorQuery extends QueryEntity<PodSimulatorState> {

  constructor(protected store: PodSimulatorStore) {
    super(store);
  }

}
